import window from 'global/window';

/*******
 * The following logic builds the Netx.URL object
 * which contains all relevant path information
 * such as host, protocol, query string, base, api
 * endpoint, etc.
 */

export const apiVersion = `v1.2`;
export const apiEndpoint = `/x7/${apiVersion}/json`;

const host: string = window.location.host;
const location: string = window.location.href.toString();
const protocol: string = location.split(host)[0];
const queryString = location.split(host)[1];
const baseDir: string = window.location.pathname;
const base = protocol + host + baseDir;

export let themeName = baseDir.match(/\/portals\/(.*)\//)?.[1] || 'netx';

const api = protocol + host + apiEndpoint;
const proxyApiEndpoint = '/core/proxy/';
const proxyApi = protocol + host + proxyApiEndpoint;

const uploadEndpoint = '/servlet/FileUploader';
const upload = protocol + host + uploadEndpoint;
const uploads3Endpoint = `${protocol}${host}/`;

/** Asset retrieval servlet (for zoom) */
const assetEndpoint = '/file/asset';
const asset = protocol + host + assetEndpoint;

const assetFileApiEndpoint = `${protocol}${host}/api/file/asset/`;

// Branding
// Login background (only for netx theme currently)
const loginBackgroundEndpoint = '/theme/netx/background';
const loginBackground = protocol + host + loginBackgroundEndpoint;

const watermarkEndpoint = `/theme/${themeName}/watermark`;
const watermark = `${protocol}${host}${watermarkEndpoint}`;

// CSS Properties (vars)
const customCssPropertiesEndpoint = `/theme/${themeName}/cssCustomProperties`;
const customCssProperties = protocol + host + customCssPropertiesEndpoint;

// Logos (only for netx theme currently)
const logoLightEndpoint = '/theme/netx/logo-light';
const logoDarkEndpoint = '/theme/netx/logo-dark';
const logoLight = protocol + host + logoLightEndpoint;
const logoDark = protocol + host + logoDarkEndpoint;

// This is to holdover portal until both `netx` and `portal` use the same branding mechanism
const themeLogo = themeName !== 'netx' ? `/theme/${themeName}/logo` : '';

/**
 * Common URLs
 */
export const URL = {
	api,
	asset,
	assetEndpoint,
	assetFileApiEndpoint,
	base,
	baseDir,
	customCssProperties,
	customCssPropertiesEndpoint,
	host,
	location,
	loginBackground,
	loginBackgroundEndpoint,
	logoDarkEndpoint,
	logoDark,
	logoLightEndpoint,
	logoLight,
	protocol,
	proxyApi,
	proxyApiEndpoint,
	queryString,
	themeLogo,
	upload,
	uploadEndpoint,
	uploads3Endpoint,
	watermark,
	watermarkEndpoint,
};

export default URL;
